export default function StyleGuideHero() {
  return (
    <section className="relative w-full h-[420px] md:h-[540px] overflow-hidden">
      {/* Background Image */}
      <img
        src="https://readdy.ai/api/search-image?query=beautiful%20fashion%20lookbook%20flat%20lay%20with%20elegant%20clothing%20pieces%20in%20cream%20beige%20and%20warm%20neutral%20tones%2C%20minimalist%20aesthetic%2C%20artistic%20arrangement%20of%20silk%20dress%20blazer%20accessories%20on%20clean%20white%20surface%2C%20soft%20natural%20lighting%2C%20high%20end%20editorial%20photography&width=1440&height=540&seq=styleguide-hero&orientation=landscape"
        alt="穿搭指南"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-6">
        <span className="inline-block border border-white/60 text-white text-sm font-sans tracking-widest px-5 py-1.5 rounded-full mb-5 font-medium">
          STYLE GUIDE
        </span>
        <h1 className="font-serif text-[2rem] md:text-[2.75rem] text-white font-semibold leading-[1.3] mb-5 max-w-2xl">
          穿搭指南
        </h1>
        <p className="font-sans text-[1.1875rem] text-white/85 leading-[1.75] max-w-xl">
          從職場到週末、從洋裝到層次穿法，讓我們帶妳探索每一種生活場景的最佳造型。
        </p>
      </div>
    </section>
  );
}
